<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Acquistions & Procurement Systems</h2>
            <ul>
                <li><a routerLink="/services">Services</a></li>
                <li>Acquistions & Procurement Systems</li>
            </ul>
        </div>
    </div>
</div>